module.exports = {
  NOT_FOUND: 404,
  FORBIDDEN: 403,
  TEAPOT: 418,
  INTERNAL_SERVER_ERROR: 500,
};
